"use client"

import { useEffect } from "react"

import { Button, Typography } from "@/components/ui/atoms"

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <main className="py-20 container flex flex-1 flex-col items-center justify-center gap-6 text-center">
      <Typography as="h1" variant="headingM">
        Une erreur est survenue
      </Typography>
      <Typography as="p" variant="paragraphM">
        Désolé, quelque chose s&apos;est mal passé. Vous pouvez réessayer ou
        revenir plus tard.
      </Typography>
      <Button onClick={() => reset()}>Réessayer</Button>
    </main>
  )
}
